import { useEffect, useRef } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogViewMyPersonalizationSize = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const loggedRef = useRef(false);

  useEffect(() => {
    if (loggedRef.current) return;
    loggedRef.current = true;

    logAnalyticsEvent({
      name: 'VIEW_MY_PERSONALIZATION',
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      analytics: {},
    });
  }, [logAnalyticsEvent]);
};
